<template>
  <v-inventory-view
    name="stock"
    :title="'all_stock_adjustment'"
    large
    to="/inventory/stock"
    v-bind:headers="headers"
    no-edit
    no-receive
    no-total
    reason
    inv-stock
  >
    <template #header="{data}">
      <v-list-item>
        <v-list-item-content>
          <v-list-item-title class="title">{{data.p_order}}</v-list-item-title>
        </v-list-item-content>
      </v-list-item>
      <v-list-item>
        <v-list-item-content>
          <v-list-item-title>
            <span class="subtitle-2">{{$t('date')}}:</span>
            <span class="body-2">{{(new Date(data.date)).toDateString()}}</span>
          </v-list-item-title>
          <v-list-item-title>
            <span class="subtitle-2">{{$t('reason')}}:</span>
            <span class="body-2">{{$t(data.reason)}}</span>
          </v-list-item-title>
          <v-list-item-title>
            <span class="subtitle-2">{{$t('adjusted_by')}}:</span>
            <span class="body-2">{{data.adjusted_by}}</span>
          </v-list-item-title>
        </v-list-item-content>
        <v-list-item-content>
          <v-list-item-title>
            <span class="subtitle-2">{{$t('store')}}:</span>
          </v-list-item-title>
          <v-list-item-subtitle>
            <span class="body-2">{{data.service_name}}</span>
          </v-list-item-subtitle>
        </v-list-item-content>
      </v-list-item>
    </template>
  </v-inventory-view>
</template>
<script>
export default {
  name: "InventoryStockView",
  data: () => ({
    // headers: {
    //   receive: [
    //     { text: "Item", value: "name" },
    //     { text: "In stock", value: "in_stock", align: "right", width: 100 },
    //     { text: "Add stock	", value: "changed", align: "right" },
    //     { text: "Cost", value: "cost", align: "right" },
    //     {
    //       text: "Stock after",
    //       value: "stock_after",
    //       align: "right",
    //       width: 100,
    //     },
    //   ],
    //   recount: [
    //     { text: "Item", value: "name" },
    //     { text: "Expected stock", value: "in_stock", align: "right" },
    //     { text: "Counted stock", value: "changed", align: "right" },
    //   ],
    //   loss: [
    //     { text: "Item", value: "name" },
    //     { text: "In stock", value: "in_stock", align: "right" },
    //     { text: "Remove stock", value: "changed", align: "right" },
    //     { text: "Stock after", value: "stock_after", align: "right" },
    //   ],
    //   damage: [
    //     { text: "Item", value: "name" },
    //     { text: "In stock", value: "in_stock", align: "right" },
    //     { text: "Remove stock", value: "changed", align: "right" },
    //     { text: "Stock after", value: "stock_after", align: "right" },
    //   ],
    // },
  }),
  computed: {
    headers() {
      let headers = []
      headers = {
        receive: [
          { text: this.$t("item"), value: "name" },
          {
            text: this.$t("in_stock"),
            value: "in_stock",
            align: "right",
            width: 100,
          },
          { text: this.$t("add_stock"), value: "changed", align: "right" },
        ],
        recount: [
          { text: this.$t("item"), value: "name" },
          {
            text: this.$t("expected_stock"),
            value: "in_stock",
            align: "right",
          },
          { text: this.$t("counted_stock"), value: "changed", align: "right" },
        ],
        loss: [
          { text: this.$t("item"), value: "name" },
          { text: this.$t("in_stock"), value: "in_stock", align: "right" },
          { text: this.$t("remove_stock"), value: "changed", align: "right" },
          { text: this.$t("stock_after"), value: "stock_after", align: "right" },
        ],
        damage: [
          { text: this.$t("item"), value: "name" },
          { text: this.$t("in_stock"), value: "in_stock", align: "right" },
          { text: this.$t("remove_stock"), value: "changed", align: "right" },
          { text: this.$t("stock_after"), value: "stock_after", align: "right" },
        ],
        fee: [
          { text: this.$t("item"), value: "name" },
          { text: this.$t("category_name"), value: "category_name" },
          { text: this.$t("in_stock"), value: "in_stock", align: "right" },
          { text: this.$t("remove_stock"), value: "changed", align: "right" },
          { text: this.$t("stock_after"), value: "stock_after", align: "right" },
        ],
      };
      if(this.user_access && this.user_access.inv_stock_adjusment_cost) {
        headers['receive'].push({ text: this.$t("cost"), value: "cost", align: "right", width: 100 })
      }
      headers['receive'].push({
        text: this.$t("stock_after"),
        value: "stock_after",
        align: "right",
        width: 100,
      })
      return headers
    }
  },
  mounted() {},
};
</script>
